// extracted by mini-css-extract-plugin
export default {"productDescription":"Kda-z","featuredDescription":"Lda-z","description":"Mda-z","more":"Nda-z","descriptionSku":"Oda-z"};